module.exports = __webpack_public_path__ + "img/avatar-04.0a5313ee.png";